import payoutStatus from '@/domain/core/constant/payoutStatus'

export const PAYOUT_STATUS = {
  PENDING: payoutStatus.pending,
  INVOICE_UPLOADED: payoutStatus.invoice_uploaded,
  INVOICE_REJECTED: payoutStatus.invoice_rejected,
  PAID: payoutStatus.paid,
  ALL: payoutStatus.all
}

export const PAYOUT_STATUS_LABELS = {
  [payoutStatus.pending]: 'Pending Invoice',
  [payoutStatus.invoice_uploaded]: 'Invoice Uploaded',
  [payoutStatus.invoice_rejected]: 'Invoice Rejected',
  [payoutStatus.paid]: 'Paid'
}

export const PAYOUT_STATUS_COLORS = {
  [payoutStatus.pending]: 'warning',
  [payoutStatus.invoice_uploaded]: 'info',
  [payoutStatus.invoice_rejected]: 'danger',
  [payoutStatus.paid]: 'success'
}

export default payoutStatus
